
import PropTypes from 'prop-types';
import {
  fetchHandler,
  createRequestHeaders,
  createResponseHandler,
} from '@/shared/api/fetchWrapper';

// Stub for logging error
export const logFetchError = error => error;

/**
 * Helper function to fetch JSON data
 * @param {String} url api endpoint /api/endpoint
 * @param {Object} options method, body, etc
 * @param {Function} responseHandler function to handle response
 * @returns {Object} json data
 * @example fetchJSON('/api/v1/endpoint', { method: 'POST', body: { hello: 'world' } });
 */
export const fetchJSON = async (
  api = '',
  options = { method: 'GET' },
  logError = logFetchError,
) => {
  try {
    const response = await fetchHandler({
      api,
      fetchParams: {
        // Create common bevy-related headers
        headers: createRequestHeaders({
          acceptType: 'application/json',
        }),
        ...options,
      },
      processBodyAs: 'json',
      throwOnError: true,
    });
    return createResponseHandler(response);
  } catch (error) {
    logError(error);
    throw error;
  }
};

fetchJSON.propTypes = {
  api: PropTypes.string.isRequired,
  options: PropTypes.object,
  responseHandler: PropTypes.func,
};

export const fetchFormData = async (
  api = '',
  options = { method: 'GET' },
  logError = logFetchError,
) => {
  try {
    const response = await fetchHandler({
      api,
      fetchParams: {
        // Create common bevy-related headers
        headers: createRequestHeaders({
          contentType: '',
          acceptType: '',
        }),
        ...options,
      },
      processBodyAs: 'formData',
      throwOnError: true,
    });
    return createResponseHandler(response);
  } catch (error) {
    logError(error);
    throw error;
  }
};
